import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { tap, map } from 'rxjs/operators';
import 'rxjs/add/operator/do';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(environment.useBackend) {
            console.log('intercept...');
            const currentUser = this.authenticationService.currentUserValue;
            if (currentUser && currentUser.access) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUser.access}`
                    }
                });
            }
        }

        return next.handle(request);
        // return next.handle(request).pipe(
        //     tap(event => {
        //       if (event instanceof HttpResponse) {
        //         console.log(event)
        //       }
        //     })
        // );
    }
}